import { defineComponent as w, ref as k, watch as x, computed as P, openBlock as o, createBlock as d, unref as a, mergeProps as C, withCtx as s, createElementBlock as y, normalizeClass as m, createElementVNode as c, createVNode as v, createCommentVNode as h, withModifiers as B, renderSlot as $, Fragment as N, renderList as W, createTextVNode as f } from "vue";
import { S as z, I as R, c as V, a as u, C as p, _ as F } from "./NavigationDrawer.vue_vue_type_style_index_1_scoped_fd5bf7fb_lang-a9e75722.mjs";
import { c7 as H, cm as S } from "./VTextarea-a9029832.mjs";
const L = { class: "align-center d-flex justify-center special-icon" }, O = ["href"], j = ["src"], M = { key: 0 }, T = { class: "align-center d-flex justify-center wrapper wrapper--social-media" }, I = /* @__PURE__ */ f("Let's link"), D = { class: "align-center d-flex justify-center wrapper" }, E = /* @__PURE__ */ f(" Terms "), A = /* @__PURE__ */ f("and"), U = /* @__PURE__ */ f(" Privacy "), q = /* @__PURE__ */ w({
  props: {
    logo: {
      type: Boolean,
      default: !1
    },
    outline: {
      type: Boolean,
      default: !1
    },
    navigationWidth: {
      type: String || Number,
      default: 300
    },
    navigationRail: {
      type: Boolean,
      default: !1
    },
    expandOnHover: {
      type: Boolean,
      default: !1
    },
    logoHeight: {
      type: Number,
      default: 60
    },
    toolbarHeight: {
      type: Number,
      default: 60
    },
    disableResizeWatcher: {
      type: Boolean,
      default: !1
    },
    disableRouteWatcher: {
      type: Boolean,
      default: !1
    },
    permanent: {
      type: Boolean,
      default: !1
    },
    logoHref: {
      type: String,
      default: "/"
    },
    mobile: {
      type: Boolean,
      default: !1
    },
    rightPanel: {
      type: Boolean,
      default: !1
    },
    showFooter: {
      type: Boolean,
      default: !0
    },
    terms: {
      type: String,
      default: ""
    },
    privacy: {
      type: String,
      default: ""
    },
    socialMediaLinks: {
      type: Array,
      default: z
    },
    rightPanelFab: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["logoClicked", "closeClicked", "updateRailValue", "rightPanelOpened"],
  setup(e, { emit: g }) {
    const t = e, r = k(!0);
    x(() => r.value, (i) => {
      g("rightPanelOpened", i);
    });
    const b = P(() => r.value ? t.navigationWidth : t.rightPanelFab ? 1 : t.navigationWidth);
    return (i, n) => (o(), d(a(H), C({
      "expand-on-hover": e.expandOnHover,
      rail: e.navigationRail,
      "rail-width": "73",
      "onUpdate:rail": n[3] || (n[3] = (l) => g("updateRailValue", l)),
      color: "side-panel-bg",
      class: [
        "c-nav",
        { "c-nav--mobile": e.mobile && !e.rightPanel },
        { "outlined-right": e.outline && !e.rightPanel },
        { "outlined-left": e.outline && e.rightPanel }
      ]
    }, i.$attrs, {
      width: e.rightPanel ? a(b) : t.navigationWidth,
      "disable-resize-watcher": t.disableResizeWatcher,
      "disable-route-watcher": t.disableRouteWatcher,
      permanent: t.permanent
    }), {
      default: s(() => [
        e.rightPanel && e.rightPanelFab ? (o(), y("div", {
          key: 0,
          class: m(["special-button d-flex", { "special-button--open": r.value }]),
          onClick: n[0] || (n[0] = (l) => r.value = !r.value)
        }, [
          c("div", L, [
            v(a(R), {
              icon: r.value ? "ph:caret-double-right" : "ph:list-plus",
              width: "20",
              color: r.value ? "rgb(var(--v-theme-copy-primary))" : "rgb(var(--v-theme-cta))"
            }, null, 8, ["icon", "color"])
          ])
        ], 2)) : h("", !0),
        t.logo && !t.mobile ? (o(), d(a(S), {
          key: 1,
          class: "drawer-header",
          color: "transparent",
          height: t.toolbarHeight
        }, {
          prepend: s(() => [
            c("a", {
              onClick: n[1] || (n[1] = (l) => g("logoClicked")),
              href: t.logoHref,
              target: "_self",
              class: "d-flex px-5"
            }, [
              c("img", {
                alt: "logo",
                src: a(V),
                style: { height: "22px" }
              }, null, 8, j)
            ], 8, O)
          ]),
          append: s(() => [
            t.mobile && i.$attrs.location !== "right" ? (o(), d(a(u), {
              key: 0,
              onClick: n[2] || (n[2] = B((l) => i.$emit("closeClicked"), ["stop"])),
              class: "close-icon mx-4",
              "icon-height": "32",
              icon: "ph:x"
            })) : h("", !0)
          ]),
          _: 1
        }, 8, ["height"])) : h("", !0),
        c("div", {
          class: m([
            "content d-flex flex-column",
            { "justify-between": e.showFooter && !e.rightPanel },
            { "content--left-no-header": !e.rightPanel && i.$attrs.order === 0 },
            { "content--left-header": !e.rightPanel && i.$attrs.order !== 0 }
          ])
        }, [
          $(i.$slots, "default", {
            class: m([{ "pt-16": t.mobile }])
          }, void 0, !0),
          e.showFooter && !e.rightPanel ? (o(), y("div", M, [
            c("div", T, [
              v(a(p), {
                variant: "body-2-400",
                "color-class": "copy-secondary"
              }, {
                default: s(() => [
                  I
                ]),
                _: 1
              }),
              (o(!0), y(N, null, W(e.socialMediaLinks, (l) => (o(), d(a(u), {
                size: "x-small",
                class: "ml-3 social-media-button",
                mode: "secondary",
                key: l.href,
                href: l.href,
                icon: l.icon,
                target: l.target,
                "icon-height": "16",
                height: "16",
                width: "16"
              }, null, 8, ["href", "icon", "target"]))), 128))
            ]),
            c("div", D, [
              (o(), d(a(u), {
                size: "x-small",
                class: "link-button",
                plain: "",
                key: e.terms,
                href: e.privacy,
                "typography-variant": "body-3-400",
                "text-color": "highlight-color",
                "no-padding": ""
              }, {
                default: s(() => [
                  E
                ]),
                _: 1
              }, 8, ["href"])),
              v(a(p), { variant: "body-3-400" }, {
                default: s(() => [
                  A
                ]),
                _: 1
              }),
              (o(), d(a(u), {
                size: "x-small",
                class: "link-button",
                plain: "",
                key: e.terms,
                href: e.privacy,
                "typography-variant": "body-3-400",
                "text-color": "highlight-color",
                "no-padding": ""
              }, {
                default: s(() => [
                  U
                ]),
                _: 1
              }, 8, ["href"]))
            ])
          ])) : h("", !0)
        ], 2)
      ]),
      _: 3
    }, 16, ["expand-on-hover", "rail", "class", "width", "disable-resize-watcher", "disable-route-watcher", "permanent"]));
  }
}), Q = /* @__PURE__ */ F(q, [["__scopeId", "data-v-fd5bf7fb"]]);
export {
  Q as C
};
